<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<h2>{{ headerText }}</h2>

<mat-dialog-content>

    <p>
        {{ verifyText }}
    </p>

    <p>
        {{ inviteA }}
        {{ inviteB }}
        {{'W_INVITEC' | translate }}
        {{'W_INVITED' | translate }}
        {{'W_INVITEE' | translate }}
    </p>

    <p>
        {{'W_NEXT' | translate}}
    </p>

    <p>
        {{'W_REVIEW' | translate}}
    </p>

    <p>
        {{'W_USE' | translate}}
    </p>

</mat-dialog-content>

<mat-dialog-actions class="button-wrapper">
    <button mat-raised-button [mat-dialog-close]="true">{{'W_ACKNOWLEDGE' | translate}}</button>
</mat-dialog-actions>
